import FlagIcon from 'components/elements/icons/FlagIcon'
import Text from 'components/elements/texts/Text'
import MainTemplate from 'components/templates/MainTemplate'
import DOMAIN from 'constants/domains'
import React from 'react'
import styled from 'styled-components'
import { getDomain } from 'utils/domain'
import { StatesProps, useServiceEndProcess } from '../../utils/commonHooks'
import { QnStatesProps } from '../../states/QnState'

/*
 * QN-17: サービス終了画面
 */

const Closed: React.FC<StatesProps> = (props: QnStatesProps) => {
  useServiceEndProcess(props)
  return (
    <MainTemplate
      title={'本サービスは\nすでに終了しております'}
      icon={<FlagIcon />}
      content={
        <React.Fragment>
          <StyledMessage>ご利用いただき、</StyledMessage>
          <StyledMessage>ありがとうございました。</StyledMessage>
        </React.Fragment>
      }
      background={'rgba(240, 240, 240, 1.0)'}
    />
  )
}

const color = {
  [DOMAIN.SAFIC]: 'var(--color-text-for-main-background)',
  [DOMAIN.SJ]: 'var(--color-text)',
}[getDomain()]

export const StyledMessage = styled(Text)`
  color: ${color};
  text-align: center;
`

export default Closed
